<div *ngIf="formGroup"
     [formGroup]="formGroup">

  <div class="row no-gutters mb-input-margin-bottom">
    <div class="col-12 col-md-12 col-sm-12 field-wrapper text-sm-left"
         mbFloatingLabel
         data-cy="mb-checkout-address-street">
      <label for="streetInformation" class="mandatory-input-asterisk mb-input-field-cursor mb-custom-label">{{ streetInformationLabelKey | cxTranslate }}</label>
      <input class="w-100 mb-form-input"
             id="streetInformation"
             name="streetInformation"
             data-cy="mb-checkout-address-street-input"
             type="text"
             formControlName="streetInformation"
             required/>
      <mb-form-errors [control]="formGroup?.get(constants.STREET_INFORMATION)"
                      [prefix]="'addressesValidationErrors'">
      </mb-form-errors>
      <span *ngIf="showPoBoxMessage" class="po-box-message">{{ 'address.us.poBoxMessage' | cxTranslate }}</span>
    </div>
  </div>

</div>
